// extracted by mini-css-extract-plugin
module.exports = {"cardStyle":"card-module--cardStyle--2-_AE","overlay":"card-module--overlay--1f1or"};